import React, {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hasLoggedOut, setHasLoggedOut] = useState(false);

    /* =========================
     * INITIAL LOAD
     * ========================= */
    useEffect(() => {
        const storedToken = localStorage.getItem("token");
        const storedUser = localStorage.getItem("user");

        if (storedToken && storedUser) {
            setToken(storedToken);
            setUser(JSON.parse(storedUser));
        }

        setLoading(false);
    }, []);

    /* =========================
     * GLOBAL LOGOUT LISTENER
     * (axios → auth)
     * ========================= */
    useEffect(() => {
        const handler = () => {
            logout("Oturum süresi doldu. Lütfen tekrar giriş yapın.");
        };

        window.addEventListener("auth:logout", handler);
        return () => window.removeEventListener("auth:logout", handler);
    }, []);

    /* =========================
     * ACTIONS
     * ========================= */
    const login = (userData, accessToken, refreshToken) => {
        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("token", accessToken);

        if (refreshToken) {
            localStorage.setItem("refreshToken", refreshToken);
        }

        setUser(userData);
        setToken(accessToken);
        setHasLoggedOut(false);
    };

    const logout = (message) => {
        if (hasLoggedOut) return;
        setHasLoggedOut(true);

        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("user");

        setUser(null);
        setToken(null);

        if (message) {
            toast.error(message);
        }

        navigate("/admin", { replace: true });
    };

    /* =========================
     * DERIVED STATE
     * ========================= */
    const isAuthenticated = !!token;
    const isAdmin = user?.role === "ADMIN";

    return (
        <AuthContext.Provider
            value={{
                user,
                token,
                login,
                logout,
                loading,
                isAuthenticated,
                isAdmin,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error("useAuth must be used inside AuthProvider");
    }
    return ctx;
};
